import React, { Component } from 'react';
import PassionItem from './PassionItem';

export default class AboutMe extends Component {
	render() {
		return (
			<section id="passion" className="bg-light-gray">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 text-center">
              <h2 className="section-heading">Current Passion</h2>
              <h3 className="section-subheading text-muted">I am currently full-time software engineer.</h3>
            </div>
          </div>
          <div className="row text-center">
						<PassionItem
							title="Chess"
							icon="fa-puzzle-piece"
							description="" />
						<PassionItem
							title="Web Development"
							icon="fa-laptop"
							description="" />
						<PassionItem
							title="Video Games"
							icon="fa-gamepad"
							description="" />
            <PassionItem
							title="Ultimate Frisbee"
							icon="fa-circle-o"
							description="" />
          </div>
        </div>
      </section>
		);
	};
}



// WEBPACK FOOTER //
// ./src/components/AboutMe.jsx